<template>
	<div class="exerciselist">
		<div class="header-exercise">
			<div class="header-div">
				<div class="left">
					<div class="title">{{info.name}}</div>
					<div class="lian">考试记录</div>
					<div class="xiang">数独题型在线练习，支持考试模拟</div>
					<div class="xiang">拟题练习和专项题型练习</div>
					<div class="red"></div>
					<div class="xiang">数独题型在线练习，支持考试模拟题练习和专项题型练习</div>
				</div>
				<div class="right">
					<img src="../../assets/10.png" />
				</div>
			</div>
		</div>
		<div class="title1">考试记录</div>
		<div class="title2">考试模拟题型，难度不代表考试难度</div>
		<div class="body">
			<div class="body-div" v-for="(item,index) in list" :key="index">
				<div class="body-title">{{item.create_time}}</div>
				<div class="body-body">
					<!-- <div>总&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;分：{{item.grade}}分</div> -->
					<div>完成数量：{{item.percentage}}</div>
					<div>时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：{{item.time}}分钟</div>
				</div>
				<div class="body-top">
					<div class="left">
						<img src="../../assets/11.png" />
						<span>设备：{{item.equipment}}</span>
					</div>
					<div class="right" >
						<router-link :to="'/exercise/details?id='+item.id+'&classify_id='+item.classify_id"  >
						<img src="../../assets/12.png" />
						<span>进入详情</span>
						</router-link>
					</div>
				</div>
			</div>
			
		</div>
		
		
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				classify_id:'',
				list  : [],
				info: [],
				
			
			}
		},
		created() {
			let that    = this;
			var  query = this.$route.query;
			that.classify_id = query.classify_id;
			if(query.classify_id){
				that.$http('get','/api/v1/question/exerciseall',{'classify_id':query.classify_id}) .then(function (res) {
					that.list = res.data.list;	
					console.log(that.list);
				});
				that.$http('get','/api/v1/classify/details',{id:query.classify_id}) .then(function (res) {  //联系方式
					that.info = res.data.info;
				});
			}
		},
		methods:{
			enterClick(e,game_id){
				let that  = this;
				 that.$router.push('./exercise?classify_id='+e+'&game_id='+game_id);
				// 
			}
		}
	}
		
</script>


<style lang="less">
	.exerciselist {
		color: #555555;
		.header-exercise {
			width: 100%;
			height: 240px;
			border: 1px solid rgba(233, 233, 233, 1);
			box-shadow: 0 5px 5px rgba(0, 0, 0, 0.0784313725490196);
			.header-div {
				width: 75%;
				margin-left: auto;
				margin-right: auto;
				margin-top: 30px;
				
				display: flex;
				.left {
					flex: 1;
					.title {
						font-size: 16px;
						height: 40px;
						
					}
					.lian {
						font-size: 18px;
						height: 30px;
					}
					.xiang {
						font-size: 10px;
						height: 16px;
					}
					.red {
						margin-top: 10px;
						width: 46px;
						height: 10px;
						border-top: 3px solid #D9001B;
					}
					
				}
				.right {
					flex: 1;
					img{
						width: 300px;
					}
				}
			}
		}
		.body {
			margin-top: 10px;
			width: 90%;
			margin-left: auto;
			margin-right: auto;
			display: flex;
			flex-wrap: wrap;
			.body-div {
				border: 1px solid rgba(233, 233, 233, 1);
				box-shadow: 0 0 5px rgba(0, 0, 0, 0.0784313725490196);
				width: 225px;
				margin: 10px;
				height: 140px;
				.body-title {
					margin-top: 2px;
					margin-left: 1px;
					padding-left: 4px;
					border-left: 3px solid #D9001B ;
					font-weight: 600;
					
				}
				.body-body {
					padding-top: 10px;
					padding-left: 30px;
					height: 76px;
					div {
						line-height: 20px;
					}
				}
				.body-top {
					display: flex;
					border-top: 1px solid  rgba(233, 233, 233, 1);
					line-height: 30px;
					font-size: 12px;
					.left {
						flex: 1;
						img {
							position: relative;
							top: 5px ;
							padding-left: 10px;
							width: 20px;
							height: 20px;
						}
						border-right: 1px solid  rgba(233, 233, 233, 1);
					}
					.right {
						flex: 1;
						img {
							position: relative;
							top: 3px ;
							padding-left: 12px;
							width: 16px;
							height: 16px;
							padding-right: 4px;
						}
					}
				}
			}
			
			
		}
		.title1 {
			margin-top: 30px;
			text-align: center;
			font-size: 24px;
		}
		.title2{
			text-align: center;
			line-height: 24px;
			font-size: 10px;
		}
		.title2:after{ content:""; width:3rem; height:3px; background-color: #D9001B; margin:0 auto 0 auto; display:block; margin-top: 3px; }
	}
</style>
